<template>
  <div class="today-study-module" v-if="todayPostContent.id">
    <div class="module-title">
      <span>{{ $t("yearCourse.learningToday") }}</span>
    </div>
    <div class="module-plan-name">
      <p class="plan-title">{{ todayPostContent.trainplan_name }}</p>
      <p class="history-btn" @click="lookHistory">
        {{ $t("yearCourse.historyCourses") }}
      </p>
    </div>
    <div class="study-content" @click="lookDetail">
      <div class="video-study" v-if="todayPostContent.type === 'video'">
        <div class="video-cover">
          <img
            :src="
              todayPostContent.img
                ? todayPostContent.img
                : 'http://weiliicimg9.pstatp.com/weili/sm/570080294980419726.webp'
            "
            class="cover-img"
          />
          <img src="@/assets/img/column_video/play.png" class="video-btn" />
        </div>
        <p class="course-name">
          {{ todayPostContent.title
          }}<span class="new-icon" v-if="todayPostContent.is_new">NEW</span>
        </p>
        <p class="author-name">
          <!-- <span v-for="(author, index) in todayPostContent.author" :key="index">{{author.name}}</span> -->
          {{ handleAuthorName(todayPostContent.author) }}
        </p>
      </div>
      <div
        class="document-study"
        v-else-if="
          todayPostContent.type === 'document' ||
          todayPostContent.type === 'article'
        "
      >
        <div class="document-icon">
          <img
            src="@/assets/img/search/doc-icon.png"
            class="type-icon"
            v-if="todayPostContent.type === 'document'"
          />
          <img
            src="@/assets/img/search/text-icon.png"
            class="type-icon"
            v-else
          />
        </div>
        <div class="right-content">
          <p class="course-name">
            {{ todayPostContent.title
            }}<span class="new-icon" v-if="todayPostContent.is_new">NEW</span>
          </p>
          <p class="author-name" style="width: 6rem">
            <!-- <span v-for="(author, index) in todayPostContent.author" :key="index">{{author.name}}</span> -->
            {{ handleAuthorName(todayPostContent.author) }}
          </p>
        </div>
      </div>
      <p class="study-reward">
        <span
          >{{ $t("yearCourse.studyCredit") }}：{{ todayPostContent.credit
          }}{{ $t("yearCourse.credit") }}</span
        >
        <span
          >{{ $t("yearCourse.lengthOfStudy") }}：{{
            todayPostContent.total_time
          }}</span
        >
      </p>
      <p class="describe">{{ todayPostContent.description }}</p>
    </div>
    <p class="look-history" @click="lookLearnList">
      {{ $t("columnVideo.seeMore") }}
    </p>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      mountedState: false,
      // 今日推送内容
      todayPostContent: {},
      // 学习类型
      studyType: "text",
    };
  },
  mounted() {
    if (!this.todayPostContent.id) {
      this.getTodayPost();
    }
  },
  activated() {
    if (this.mountedState) {
      this.getTodayPost();
    }
  },
  methods: {
    ...mapMutations("yearCourse", ["setCourseDetailDiscuss"]),
    getTodayPost() {
      this.$axios
        .post(`index.php/mobile/index/learning-today`, {})
        .then((res) => {
          this.mountedState = true;
          if (res.data.code === 0) {
            this.todayPostContent =
              res.data.result.length > 0 ? res.data.result[0] : {};
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
    // 查看详情
    lookDetail() {
      this.setCourseDetailDiscuss({
        break: true,
        top: 0,
      });
      if (this.todayPostContent.res_time_status == "3") {
        return this.$toast(this.$t("learningCamp.ResourcesExpired"));
      } else if (this.todayPostContent.res_time_status == "1") {
        return this.$toast("资源未生效");
      } else if (this.todayPostContent.res_time_status == "4") {
        return this.$toast("资源未授权或资源已删除");
      }
      this.$router.push({
        path: "/main/365course",
        query: {
          cid: this.todayPostContent.id,
          tid: this.todayPostContent.trainplan_id,
          rid: this.todayPostContent.resources_id,
        },
      });
    },
    // 往期回顾
    lookHistory() {
      this.$router.push({
        path: "/main/365historyStudy",
        query: {
          tid: this.todayPostContent.trainplan_id,
          rid: this.todayPostContent.resources_id,
        },
      });
    },
    // 查看全部
    lookLearnList() {
      this.$router.push({
        path: "/learnListToday",
      });
    },
    handleAuthorName(value) {
      if (value.length > 0) {
        let str = "";
        for (let i = 0; i < value.length; i++) {
          if (i == 0) {
            str += value[i].name;
          } else {
            str += `\xa0\xa0|\xa0\xa0` + value[i].name;
          }
        }
        return str;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";
.today-study-module {
  overflow-x: hidden;
  background: white;
  margin-bottom: 0.2rem;
  .module-title {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0.73rem;
    font-size: 0.28rem;
    border-bottom: 0.02rem solid #ddd;
    &::before {
      content: "";
      background: #666;
      width: 0.22rem;
      height: 0.02rem;
    }
    &::after {
      content: "";
      background: #666;
      width: 0.22rem;
      height: 0.02rem;
    }
    span {
      margin: 0 0.1rem;
    }
  }
  .module-plan-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.3rem;
    margin: 0.3rem auto 0;
    .plan-title {
      flex: 1;
      overflow: hidden;
      font-size: 0.3rem;
      font-weight: 750;
      margin-right: 0.2rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
      padding-left: 0.15rem;
      &::before {
        content: "";
        width: 0.05rem;
        height: 0.3rem;
        background: @mColor;
        border-radius: 0.03rem;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .history-btn {
      font-size: 0.22rem;
      padding: 0.05rem 0.15rem;
      color: @mColor;
      border: 0.03rem solid #eee;
      border-radius: 0.25rem;
    }
  }
  .look-history {
    color: @mColor;
    text-align: center;
    font-size: 0.22rem;
    line-height: 0.66rem;
    border-top: 0.02rem solid #ddd;
  }
  .study-content {
    padding: 0 0.3rem;
    margin: 0.3rem auto;
    .author-name {
      font-size: 0.26rem;
      color: #7f8485;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      /* display: flex; */
      span {
        padding-left: 0.18rem;
        display: flex;
        align-items: center;
        &::after {
          content: "";
          height: 0.18rem;
          width: 0.02rem;
          background: #dfdfdf;
          margin-left: 0.18rem;
        }
      }
      span:first-child {
        padding-left: 0;
      }
      span:last-child {
        &::after {
          content: "";
          height: 0;
        }
      }
    }
    .study-reward {
      color: #7f8485;
      font-size: 0.22rem;
      margin-top: 0.06rem;
      display: flex;
      span {
        margin-right: 0.3rem;
      }
    }
    .describe {
      font-size: 0.26rem;
      margin-top: 0.15rem;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .new-icon {
    background: @unPassColor;
    color: white;
    display: inline-block;
    line-height: 1.5;
    font-size: 0.16rem;
    margin-left: 0.05rem;
    border-radius: 0.04rem;
    transform: translateY(-0.15rem);
    padding: 0.02rem 0.1rem 0;
    position: relative;
    z-index: 10;
    &::after {
      position: absolute;
      content: "";
      width: 0.1rem;
      height: 0.16rem;
      transform: skewY(-50deg);
      background: @unPassColor;
      bottom: -0.03rem;
      left: 0.1rem;
      z-index: -1;
    }
  }
  .video-study {
    .video-cover {
      overflow: hidden;
      height: 3.66rem;
      position: relative;
      .cover-img {
        width: 100%;
        height: 100%;
      }
      .video-btn {
        width: 1.1rem;
        .absolutely-centered;
      }
    }
    .course-name {
      font-size: 0.3rem;
      margin: 0.25rem 0 0.05rem;
      font-weight: 750;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .document-study {
    display: flex;
    .document-icon {
      position: relative;
    }
    .type-icon {
      width: 0.52rem;
      height: 0.58rem;
    }
    .right-content {
      flex: 1;
      margin-left: 0.3rem;
    }
    .course-name {
      font-size: 0.3rem;
      font-weight: 750;
      margin-bottom: 0.05rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
